import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from 'components/Dialog';
import { closeAddSecProfile } from 'reducers/DialogsReducer';
import { Button } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import TextField from '@material-ui/core/TextField';
import { findSecCode, createSecProfile } from 'Settings/Security/SecFunctions';
import { handleError } from 'reducers/ErrorReducer';
import { notify } from 'reducers/NotifierReducer';
import { gridStyle } from 'utils/formStyles';
import Autocomplete2 from 'components/Autocomplete2';
import { notifyDataUpdate } from 'reducers/DataUpdateReducer';


const useStyles = makeStyles(theme => ({
  item: {
    ...gridStyle(200, 800),
    margin: 0,
  }
}));

const AddSecProfileDialog = (props) => {
  const classes = useStyles();
  const [name, setName] = useState('');
  const [currentType, setCurrentType] = useState(null);
  const [allTypes, setAllTypes] = useState([]);


  useEffect(() => {
    fetchTypes();
  }, [])


  const fetchTypes = async () => {
    const types = await findSecCode('profiletype');
    setAllTypes(types);
  }


  const close = () => {
    props.closeAddSecProfile();
  }

  const save = async () => {
    const data = {
      Label: name,
      Type: currentType?.Code || null,
    }
    try{
      const result = await createSecProfile(data);
      props.notifyDataUpdate({type: 'add-profile', data: result.ptsProfileID});
      props.notify("New Profile Created", "success");
      props.closeAddSecProfile();
    } catch(err) {
      props.handleError(err, 'Error Creating New Profile');
    }
  }

  const renderActions = () => {
    return (
      <>
        <Button color="primary" variant="contained" autoFocus onClick={save} disabled={!name} >
          <SaveIcon /> Save
        </Button>
        <Button color="primary" onClick={close}>
          <CloseIcon /> Close
        </Button>
      </>
    );
  };


  const renderName = () => {
    return (
      <TextField 
        label="Profile Name"
        variant="outlined"
        value={name}
        size="small"
        onChange={(e) => setName(e.target.value)}
        fullWidth
      />
    )
  }


  const renderType = () => {
    const handleChange = (e, newValue) => setCurrentType(newValue);
    return (
      <div className='mt-3'>
        <Autocomplete2
          options={allTypes}
          className={classes.item}
          onChange={handleChange}
          value={currentType}
          label="Profile Type"
          getOptionLabel={option => option.Code}
          getOptionSelected={(option, value) => option.Code === value.Code}
          renderOption={option => `${option.Code} ${option.Description ? '- ' + option.Description : ''}`}
        />
      </div>
    )
  }


  return (
    <Dialog onClose={close} title="Add New Profile" actions={renderActions()} >
      <div>
        {renderName()}
        {renderType()}
      </div>
    </Dialog>
  )
}


export default connect(null, {  closeAddSecProfile, handleError, notify, notifyDataUpdate, })(AddSecProfileDialog);